import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import * as ReactRouter from 'react-router-dom';
import PropTypes from 'prop-types';
import lock from '../../../components/Auth/lock';
import { parseQueryParams } from '../../../utils/queryStringUtils';
import {
  homeRoute,
  superAdminHomeRoute,
  toolingLocationRoute,
  // solicitationsSearchRoute,
} from '../../../config/navigation/routes';
import { checkIfAuthIsValid } from '../../../utils/authUtils';

class IntermediateLogin extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    // Store callback references to properly clean up later
    this.handleHide = this.handleHide.bind(this);
  }

  handleHide = () => {
    console.log("Auth0 lock hidden");
    if (!checkIfAuthIsValid(this.props.auth)) {
      this.props.history.push(homeRoute);
    }
  }

  componentDidMount() {
    const { history } = this.props;
    const parsedQueryParams = parseQueryParams(history.location.search);

    // If user is not authenticated and there's a redirect parameter, store it for after login
    if (!checkIfAuthIsValid(this.props.auth) && parsedQueryParams.redirect) {
      sessionStorage.setItem('auth_redirect_url', parsedQueryParams.redirect);
      console.log('Stored redirect URL for after login:', parsedQueryParams.redirect);
    }

    // Show the lock with a small delay to ensure component is fully rendered
    setTimeout(() => {
      lock.show();
    }, 100);

    // Set up listeners with proper reference to the handler
    lock.on('hide', this.handleHide);

    // Get a fresh promise for this login attempt
    const authPromise = lock.getAuthorizedPromise ? lock.getAuthorizedPromise() : lock.authorizedPromise;

    // Handle successful authentication
    authPromise
      .then(jwtToken => {
        console.log("Auth0 lock authorized, processing login");
        this.props.login(jwtToken);
      })
      .catch(error => {
        console.error("Auth0 lock error:", error);
        this.props.history.push(homeRoute);
      });
  }

  componentWillUnmount() {
    // Ensure we clean up any listeners when unmounting, using the stored reference
    lock.off('hide', this.handleHide);
    // Don't try to remove 'authenticated' because we're not using that event
  }

  render() {
    const { auth, history } = this.props;

    const parsedQueryParams = parseQueryParams(history.location.search);
    // The following logic redirects the user based on role to the corresponding route
    let redirectRoute = homeRoute; // Default to home route

    if (auth.role === 'SUPER_ADMIN') {
      redirectRoute = superAdminHomeRoute;
    } else if (auth.role === 'GOVERNMENT_USER') {
      redirectRoute = toolingLocationRoute;
    }

    const targetUrl = parsedQueryParams.redirect
      ? parsedQueryParams.redirect
      : redirectRoute;

    return (
      <div className="nf-intermediate-login">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Login Page</title>
        </Helmet>
        {checkIfAuthIsValid(auth) && <ReactRouter.Redirect to={targetUrl} />}
      </div>
    );
  }
}

export default IntermediateLogin;



// WEBPACK FOOTER //
// ./src/pages/static/IntermediateLogin/IntermediateLogin.jsx